export class AlarmListChangeEvent {
    Timestamp: Date;

    constructor() {
        this.Timestamp = new Date();
    }
}